var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 30.625,
    stroke: "white",
    strokeWidth: 3.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4539 22.9656C22.7788 23.6407 22.7788 24.7352 23.4539 25.4103L30.544 32.5004L23.4543 39.5901C22.7792 40.2652 22.7792 41.3598 23.4543 42.0349C24.1294 42.71 25.224 42.71 25.8991 42.0349L32.9887 34.9452L39.5895 41.5459C40.2646 42.221 41.3591 42.221 42.0342 41.5459C42.7093 40.8708 42.7093 39.7762 42.0342 39.1011L35.4335 32.5004L42.0347 25.8993C42.7098 25.2242 42.7098 24.1296 42.0347 23.4545C41.3595 22.7794 40.265 22.7794 39.5899 23.4545L32.9887 30.0556L25.8987 22.9656C25.2236 22.2904 24.129 22.2904 23.4539 22.9656Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4539 22.9656C22.7788 23.6407 22.7788 24.7352 23.4539 25.4103L30.544 32.5004L23.4543 39.5901C22.7792 40.2652 22.7792 41.3598 23.4543 42.0349C24.1294 42.71 25.224 42.71 25.8991 42.0349L32.9887 34.9452L39.5895 41.5459C40.2646 42.221 41.3591 42.221 42.0342 41.5459C42.7093 40.8708 42.7093 39.7762 42.0342 39.1011L35.4335 32.5004L42.0347 25.8993C42.7098 25.2242 42.7098 24.1296 42.0347 23.4545C41.3595 22.7794 40.265 22.7794 39.5899 23.4545L32.9887 30.0556L25.8987 22.9656C25.2236 22.2904 24.129 22.2904 23.4539 22.9656Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancell);
export default __webpack_public_path__ + "static/media/cancell.0cba5aa5f2bc848ab3768b66c77b4667.svg";
export { ForwardRef as ReactComponent };